
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.529 3.029c.26-.26.682-.26.943 0l2.997 2.997a.65.65 0 01.142.206.666.666 0 01-.142.742l-2.997 2.998a.667.667 0 01-.943-.943l1.862-1.862h-2.079a5.333 5.333 0 00-5.166 4 .667.667 0 01-1.291-.333 6.667 6.667 0 016.458-5h2.078l-1.862-1.862a.667.667 0 010-.943zM2 4.833c.368 0 .667.299.667.667v7.334H12a.667.667 0 010 1.333H2a.667.667 0 01-.667-.667v-8c0-.368.299-.667.667-.667z","fill":"#282E3E"}})])
          )
        }
      }
    